import { Card, CardContent, CardHeader, Stack } from '@packages/shared';
import { useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { legalHintsCardMessages } from './messages';
import { LegalHintsItem } from '../LegalHintsItem';

/*
 * INFO: As of right now the data structure for productHints and legalHints is the same, so the components are mostly identical.
 * The data for these two might change in the future and then the two components would have to be split again. For this reason we decided to split into seperate cards them from the start.
 */

const LegalHintsCardFragment = graphql(/* GraphQL */ `
  fragment LegalHintsCardFragment on Product {
    legalHints {
      ...LegalHintsItemFragment
    }
  }
`);

export type LegalHintsCardProps = {
  legalHintsData: FragmentType<typeof LegalHintsCardFragment>;
};

/**
 * LegalHintsCard component displays all available legal hints
 * */
export const LegalHintsCard = ({ legalHintsData }: LegalHintsCardProps) => {
  const { legalHints } = getFragmentData(LegalHintsCardFragment, legalHintsData);

  const { formatMessage } = useIntl();

  if (legalHints.length === 0) return null;

  return (
    <Card>
      <CardHeader
        title={formatMessage(legalHintsCardMessages.legalHintsCardHeader)}
        sx={{ borderBottom: 1, borderColor: 'grey.main', py: 1, px: 2 }}
      />
      <CardContent>
        <Stack spacing={1.5}>
          {legalHints.map((legalHint, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <LegalHintsItem legalHintsData={legalHint} key={idx} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
